module.exports = __webpack_public_path__ + "img/3@3x.09bc3907.png";